import Permission, { PermissionButton } from './components/Permission';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  PermissionButton(bm, labelShoppingCartCategory, labels.permissionButton, types.permissionButton);
  Permission(dc, labels.permissionButton, types.permissionButton, opts);
};
